import { AxiosError } from 'axios';
import { useGet } from 'lib/swr-crud';
import { APIErrorResponse, APISortDirection } from 'lib/utils';
import {
  getOrdersByUserId,
  GetOrdersByUserIdResponse,
  getOrdersByUserIdUrl,
} from './api';
import { OrderAPISortBy, OrderAPIStatus } from './interface';

const useLastCompletedOrder = (userId: string | null) => {
  const shouldFetch = userId !== null;
  const params = {
    page: '1',
    perPage: '1',
    status: OrderAPIStatus.COMPLETED,
    sortDir: APISortDirection.DESCENDING,
    sortField: OrderAPISortBy.CREATED_AT,
  };
  const url = shouldFetch
    ? getOrdersByUserIdUrl(userId, params)
    : null;

  const { data, isLoading } = useGet<
    GetOrdersByUserIdResponse,
    AxiosError<APIErrorResponse>
  >(url, async () => await getOrdersByUserId(userId!, params));

  const order = data?.data?.[0] ?? null;

  return { order, isLoading };
};

export default useLastCompletedOrder;
